export class PauseableTimeout {
    private timerId: number | null = null;
    private start = 0;
    private remaining = 0;
    private callback: (() => void) | null = null;

    begin(callback: () => void, delay: number) {
        this.clear();
        this.remaining = delay;
        this.callback = callback;
        this.resume();
    }

    pause() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
            this.remaining -= Date.now() - this.start;
        }
    }

    resume() {
        if (this.timerId !== null || !this.callback || this.remaining <= 0) return;

        this.start = Date.now();
        this.timerId = window.setTimeout(() => {
            try {
                this.callback?.();
            } catch (e) {
                console.error('PauseableTimeout callback error:', e);
            }
            this.timerId = null;
        }, this.remaining);
    }

    clear() {
        if (this.timerId !== null) {
            clearTimeout(this.timerId);
            this.timerId = null;
        }
        this.callback = null;
    }
}
